import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Chip,
  Paper,
  Tab,
  Tabs,
  Box,
  MenuItem,
  Button,
  Menu,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import apiConfigs from "../../config/config";
import StarIcon from "@material-ui/icons/Star";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import {
  changePaymentStatus,
  confirmBooking,
  userInvitation,
} from "../../store/action";
import history from "../../utils/HistoryUtils";
import Notification from "../../components/Notification/Notification";
import { GetApp, Mail } from "@material-ui/icons";
import CandidatesTable from "./CandidatesTable";

const useStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.main
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    cursor: "pointer",
  },

  tabChip: {
    padding: 0,
    margin: "1px",
    height: 26,
    "& .MuiChip-label": {
      padding: "0 8px",
      minWidth: 26,
    },
  },

  actionButtonsRow: {
    display: 'flex',
    alignItems: 'center',
    '& > * + *': { marginLeft: theme.spacing(2) }, // add space between siblings
  },

}));

// Simple Tab Panel wrapper
const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index}>{value === index && <Box p={2}>{children}</Box>}</div>
);

const CandidatesList = ({
  bookingDetail,
  booking_id,
  getBookingDetail,
  setConfirmBtn,
}) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElRowInfo, setAnchorElRowInfo] = React.useState(null);
  const [getSigneeid, setGetSigneeid] = React.useState();
  const open = Boolean(anchorEl);
  const [signeeSizeMsg, setSigneeSize] = useState("");
  const [confirmNotify, setConfirmNotify] = useState(false);
  const [selected, setSelected] = React.useState([]);
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const loginDetail = JSON.parse(localStorage.getItem("loginUserInfo"));
  const {
    confirmBookingSuccess,
    confirmBookingError,
    invitationSuccess,
    shiftStatusSuccess,
  } = useSelector((state) => state.booking);

  // for confirmed past date checking
  var GivenDate = bookingDetail && bookingDetail?.data?.date;
  GivenDate = new Date(GivenDate);
  var CurrentDate = new Date();
  const pastDate = bookingDetail?.data?.is_past;
  // const pastDate = GivenDate < CurrentDate ? true : false

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSigneeSize("");
  };

  const [bookingData, setBookingData] = useState({
    booking_id: booking_id,
    signee_id: "",
    status: "",
  });
  const handleMenuItem = (data, signeeId) => {
    setBookingData({ ...bookingData, status: data, signee_id: signeeId });
    setAnchorEl(null);
  };

  useEffect(() => {
    if (bookingData.status !== "") {
      dispatch(confirmBooking(bookingData));
      setConfirmNotify(true);
      setTimeout(() => {
        getBookingDetail();
      }, 4000);
    }
  }, [bookingData]);

  const [pdfData, setPdfData] = useState({
    booking_id: booking_id,
    signee_id: [],
  });

  const [paymentStatus, setPaymentStatus] = useState({
    booking_id: booking_id,
    signee_id: "",
    payment_status: "",
  });

  const handlePaymentStatus = (event, sId) => {
    setPaymentStatus({
      ...paymentStatus,
      [event.target.name]: event.target.value,
      signee_id: sId,
    });
  };

  useEffect(() => {
    if (paymentStatus.payment_status !== "") {
      dispatch(changePaymentStatus(paymentStatus));
      setTimeout(() => {
        getBookingDetail();
      }, 4000);
    }
  }, [paymentStatus]);

  const signeePage = (e, signeeId) => {
    e.preventDefault();
    const adminUrl = loginDetail.role === "ORGANIZATION" ? "admin" : "staff";
    history.push(`/${adminUrl.toLowerCase()}/candidate/${signeeId}/detail`);
  };

  const downloadPdf = async () => {
    if (pdfData.signee_id.length === 0) {
      setSigneeSize("Please selected at least one candidate to download pdf");
      return;
    }
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .post(`${apiConfigs.API_URL}api/organization/user/pdf`, pdfData, {
        headers: {
          Authorization: getToken ? `Bearer ${getToken}` : "",
        },
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Candidate.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const handleClose = (data) => {
    setAnchorEl(null);
    setAnchorElRowInfo(null);
  };

  const handleMenu = (event, id, row) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
    setAnchorElRowInfo(row);
    setGetSigneeid(id);
    setConfirmBtn(row.status === "CONFIRMED" ? true : false);
  };

  const usersInvitation = () => {
    dispatch(userInvitation(pdfData));
    setConfirmNotify(true);
    setTimeout(() => {
      window.location.reload();
    }, 4000);
  };

  const handleCheckboxClick = (event) => {
    const specialityData = JSON.parse(JSON.stringify(pdfData));
    const isChecked = event.target.checked;
    if (isChecked) {
      specialityData.signee_id.push(parseFloat(event.target.value));
      setPdfData(specialityData);
    } else {
      const newData = specialityData.signee_id.filter(
        (item) => item !== parseFloat(event.target.value)
      );
      specialityData.signee_id = newData;
      setPdfData(specialityData);
    }
  };

  useEffect(() => {
    bookingDetail?.data?.matching &&
      bookingDetail?.data?.matching
        .filter((item) => item.signee_booking_status === "CONFIRMED")
        .map((list, index) => {
          return setConfirmBtn(true);
        });
  }, [bookingDetail?.data?.matching]);

  useEffect(() => {
    bookingDetail?.data?.interested &&
      bookingDetail?.data?.interested
        .filter((item) => item.signee_booking_status === "CONFIRMED")
        .map((list, index) => {
          return setConfirmBtn(true);
        });
  }, [bookingDetail?.data?.interested]);

  return (
    <>
      {confirmBookingError && confirmBookingError?.message && (
        <Notification data={confirmBookingError.message} status="error" />
      )}
      {signeeSizeMsg && <Notification data={signeeSizeMsg} status="error" />}
      {confirmNotify && invitationSuccess?.message && (
        <Notification data={invitationSuccess?.message} status="success" />
      )}


      <Paper className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center" pl={2} pr={2}>
          <Tabs value={value} onChange={handleChange}>
            {!pastDate && (
              <Tab
                label={
                  <Box>
                    Matching Candidates
                    <Chip
                      label={bookingDetail?.data?.matching.filter((item) => item.compliance_status === "COMPLIANT").length || 0}
                      color="primary"
                      className={classes.tabChip}
                    />
                  </Box>
                }
              />
            )}
            {!pastDate && (
              <Tab
                label={
                  <Box>
                    Interested Candidates
                    <Chip
                      label={bookingDetail?.data?.interested.length || 0}
                      color="primary"
                      className={classes.tabChip}
                    />
                  </Box>
                }
              />
            )}

            {pastDate && (
              <Tab
                label={
                  <Box>
                    Candidates
                    <Chip
                      label={bookingDetail?.data?.confirmed.filter((item) => item.compliance_status === "COMPLIANT").length || 0}
                      color="primary"
                      className={classes.tabChip}
                    />
                  </Box>
                }
              />
            )}
          </Tabs>

          <Box className={classes.actionButtonsRow}>
            {(pastDate || (pdfData.signee_id.length > 0)) && (
              <Button variant="contained" color="primary" onClick={downloadPdf} startIcon={<GetApp />} >
                Download PDF
              </Button>
            )}

            {pdfData.signee_id.length > 0 && bookingDetail?.data?.status === "CREATED" && (
              <Button variant="contained" color="primary" startIcon={<Mail />} onClick={usersInvitation}>
                Send invitation
              </Button>
            )}
          </Box>
        </Box>

        {!pastDate && (
          <>
            <TabPanel value={value} index={0}>
              <CandidatesTable
                rows={bookingDetail?.data?.matching?.filter(
                  (i) => i.compliance_status === "COMPLIANT"
                )}
                pastDate={pastDate}
                status={bookingDetail?.data?.status}
                pdfData={pdfData}
                handleCheckboxClick={handleCheckboxClick}
                handlePaymentStatus={handlePaymentStatus}
                signeePage={signeePage}
                handleMenu={handleMenu}
                staffDetail={staffDetail}
                classes={classes}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <CandidatesTable
                rows={bookingDetail?.data?.interested}
                pastDate={pastDate}
                status={bookingDetail?.data?.status}
                pdfData={pdfData}
                handleCheckboxClick={handleCheckboxClick}
                handlePaymentStatus={handlePaymentStatus}
                signeePage={signeePage}
                handleMenu={handleMenu}
                staffDetail={staffDetail}
                classes={classes}
              />
            </TabPanel>
          </>
        )}

        {pastDate && (
          <TabPanel value={value} index={0}>
            <CandidatesTable
              rows={bookingDetail?.data?.confirmed?.filter(
                (i) => i.compliance_status === "COMPLIANT"
              )}
              pastDate={pastDate}
              status={bookingDetail?.data?.status}
              pdfData={pdfData}
              handleCheckboxClick={handleCheckboxClick}
              handlePaymentStatus={handlePaymentStatus}
              signeePage={signeePage}
              handleMenu={handleMenu}
              staffDetail={staffDetail}
              classes={classes}
            />
          </TabPanel>
        )}
      </Paper>

      {anchorEl && (
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={open}
          onClose={handleClose}
        >
          {anchorElRowInfo.signee_booking_status === "PENDING" && (
            <MenuItem onClick={() => handleMenuItem("OFFER", anchorElRowInfo.signeeId)} className={classes.menuItem}>
              <CheckIcon className="mr-2" /> Offer
            </MenuItem>
          )}
          {anchorElRowInfo.signee_booking_status !== "CONFIRMED" &&
            anchorElRowInfo.signee_booking_status === "ACCEPT" && (
              <MenuItem onClick={() => handleMenuItem("CONFIRMED", anchorElRowInfo.signeeId)} className={classes.menuItem}>
                <CheckIcon className="mr-2" /> Confirm
              </MenuItem>
            )}
          {anchorElRowInfo.signee_booking_status !== "APPLY" &&
            // anchorElRowInfo.signee_booking_status !== "OFFER" &&
            anchorElRowInfo.signee_booking_status !== "CONFIRMED" &&
            anchorElRowInfo.signee_booking_status !== "REJECTED" && (
              <MenuItem
                onClick={() =>
                  handleMenuItem("CONFIRMED", anchorElRowInfo.signeeId)
                }
                className={classes.menuItem}
              >
                <StarIcon className="mr-2" />
                Super Assign
              </MenuItem>
            )}
          {anchorElRowInfo.signee_booking_status !== "CONFIRMED" &&
            anchorElRowInfo.signee_booking_status === "APPLY" && (
              <MenuItem
                onClick={() =>
                  handleMenuItem("CONFIRMED", anchorElRowInfo.signeeId)
                }
                className={classes.menuItem}
              >
                <StarIcon className="mr-2" />
                Accept
              </MenuItem>
            )}
          {anchorElRowInfo.signee_booking_status !== "REJECTED" && (
            <MenuItem
              onClick={() =>
                handleMenuItem("REJECTED", anchorElRowInfo.signeeId)
              }
              className={classes.menuItem}
            >
              <CloseIcon className="mr-2" />
              Reject
            </MenuItem>
          )}
        </Menu>
      )}
    </>
  );
};

export default CandidatesList;
